<script>
  import { onMount } from 'svelte';
  import { MDCChipSet } from '@material/chips';

  export let chips;
  export let current_page;
  export let current_chip;
  export let current_group;
  export let headers;

  let chip_set;

  const chip_selection = async e => {
    current_page = 1;

    for (let i = 0; i < chips.length; i++) {
      if (chips[i].id === e.chipId) {
        chips[i].selected = true;
        current_chip = i;
        current_group = chips[i].group;
        await window.get_data_from_api(current_group);
      } else {
        chips[i].selected = false;
      }
    }

    for (let i = 0; i < chips.length; i++) {
      if (e.value === 'type' + i) {
        for (let j = 0; j < headers.length; j++) {
          headers[j].show = !!chips[i].showed_columns.includes(j);
        }
      }
    }
  };

  const init_chips = () => {
    const chipSetEl = document.querySelector('.mdc-chip-set');
    if (chipSetEl) {
      chip_set = new MDCChipSet(chipSetEl);
      addEventListener('MDCChip:selection', event => {
        chip_selection({ ...event.detail, value: event.target.dataset.value });
      });
    }
  }

  onMount(init_chips);
</script>

<div class='mdc-chip-set mdc-chip-set--filter'>
  {#each chips as chip, i}
    <div
      class='mdc-chip mdc-ripple-upgraded mdc-chip-margin'
      class:undefined={chip.selected === false}
      class:mdc-chip--selected={chip.selected === true}
      class:chip-disabled={chip.enabled === false}
      role='row'
      id={chip.id}
      data-value={chip.value}
      disabled>

      {#if chip.icon !== null}
        <i
          class='material-icons mdc-chip__icon mdc-chip__icon--leading
          mdc-chip__icon--leading'>
          {chip.icon}
        </i>
      {/if}

      <div class='mdc-chip__checkmark'>
        <svg class='mdc-chip__checkmark-svg' viewBox='-2 -3 30 30'>
          <path
            class='mdc-chip__checkmark-path'
            fill='none'
            stroke='black'
            d='M1.73,12.91 8.1,19.28 22.79,4.59' />
        </svg>
      </div>
      <span role='button' tabindex='0' class='mdc-chip__text'>{chip.name}</span>
    </div>
  {/each}

</div>

<style>

    .material-icons {
        color: var(--mdc-theme-primary);
    }

    .mdc-chip-margin {
        margin-top: 8px;
        margin-bottom: 8px;
    }

    .chip-disabled {
        pointer-events: none;
        cursor: default;
        background-color: #cccccc;
    }
</style>